<template>
  <div class="min-h-screen bg-gradient-to-br from-slate-900 via-slate-800 to-slate-900 relative">
    <!-- Animated Background -->
    <div class="fixed inset-0 bg-[radial-gradient(ellipse_at_center,_var(--tw-gradient-stops))] from-emerald-900/20 via-transparent to-transparent pointer-events-none"></div>
    <div class="fixed inset-0 bg-grid-pattern opacity-10 pointer-events-none"></div>
    
    <!-- Floating Particles -->
    <div class="fixed inset-0 pointer-events-none">
      <div class="particle particle-1"></div>
      <div class="particle particle-2"></div>
      <div class="particle particle-3"></div>
      <div class="particle particle-4"></div>
      <div class="particle particle-5"></div>
    </div>

    <!-- Modern Sidebar Navigation -->
    <div class="sidebar fixed inset-y-0 left-0 z-50 bg-slate-800/90 backdrop-blur-xl border-r border-slate-700/50 flex flex-col overflow-y-auto custom-scrollbar" style="width: 288px; min-width: 288px;">
      <!-- Logo Section -->
      <div class="p-6 border-b border-slate-700/50 flex-shrink-0">
        <router-link to="/" class="flex items-center space-x-3 group">
          <div class="w-12 h-12 bg-gradient-to-br from-emerald-400 to-cyan-400 rounded-2xl flex items-center justify-center shadow-lg shadow-emerald-500/25 group-hover:scale-105 transition-transform">
            <svg class="w-7 h-7 text-white" fill="currentColor" viewBox="0 0 20 20">
              <path d="M10 2a8 8 0 100 16 8 8 0 000-16zM8 14a6 6 0 1112 0H8z"/>
            </svg>
          </div>
          <div>
            <span class="text-2xl font-bold bg-gradient-to-r from-emerald-400 to-cyan-400 bg-clip-text text-transparent group-hover:from-emerald-300 group-hover:to-cyan-300 transition-all duration-300">OilBuddy</span>
            <p class="text-xs text-slate-400 font-medium">Admin Platform</p>
          </div>
        </router-link>
      </div>

      <!-- Navigation Menu -->
      <nav class="flex-1 px-4 py-6 space-y-2">
        <div class="mb-8">
          <div class="flex items-center px-3 py-2 text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">
            <span>Main</span>
          </div>
          <div class="space-y-1">
            <router-link to="/admin" class="nav-item group">
              <img src="/src/assets/images/icons/growth chart.png" alt="Dashboard" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Dashboard</span>
            </router-link>
            
            <router-link to="/admin/users" class="nav-item group">
              <img src="/src/assets/images/icons/checklist and pen.png" alt="Users" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Users</span>
            </router-link>

            <router-link to="/admin/jobs" class="nav-item group">
              <img src="/src/assets/images/icons/handshake.png" alt="Jobs" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Jobs</span>
            </router-link>

            <router-link to="/admin/payroll" class="nav-item group">
              <img src="/src/assets/images/icons/money and dollar.png" alt="Payroll" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Payroll</span>
            </router-link>
          </div>
        </div>

        <div class="mb-8">
          <div class="flex items-center px-3 py-2 text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">
            <span>Management</span>
          </div>
          <div class="space-y-1">
            <router-link to="/admin/email" class="nav-item group">
              <img src="/src/assets/images/icons/blue chat bubble.png" alt="Email Management" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Email Management</span>
            </router-link>

            <router-link to="/admin/plans" class="nav-item group">
              <img src="/src/assets/images/icons/gold dollar coin.png" alt="Plans Management" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Plans Management</span>
            </router-link>

            <router-link to="/admin/analytics" class="nav-item group">
              <img src="/src/assets/images/icons/ai-powered financial research tools.png" alt="Analytics" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Analytics</span>
            </router-link>

            <router-link to="/admin/knowledge" class="nav-item group">
              <img src="/src/assets/images/icons/books.png" alt="Knowledge Hub" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Knowledge Hub</span>
            </router-link>

            <router-link to="/admin/blog" class="nav-item group">
              <img src="/src/assets/images/icons/megaphone announcement.png" alt="Blog" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Blog</span>
            </router-link>

            <router-link to="/admin/roadmap" class="nav-item group">
              <img src="/src/assets/images/icons/growth chart.png" alt="Roadmap Management" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Roadmap Management</span>
            </router-link>

            <router-link to="/admin/ai-agents" class="nav-item group">
              <img src="/src/assets/images/icons/ai-agent.png" alt="AI Agents" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>AI Agents</span>
            </router-link>

            <router-link to="/admin/amazon-api" class="nav-item group">
              <img src="/src/assets/images/icons/gear icon with neon.png" alt="Amazon API" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Amazon API</span>
            </router-link>

            <router-link to="/admin/settings" class="nav-item group">
              <img src="/src/assets/images/icons/gear icon with neon.png" alt="Settings" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Settings</span>
            </router-link>
          </div>
        </div>

        <div class="mb-8">
          <div class="flex items-center px-3 py-2 text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">
            <span>Safety</span>
          </div>
          <div class="space-y-1">
            <router-link to="/admin/safety/incidents" class="nav-item group">
              <img src="/src/assets/images/icons/shiny blue shield.png" alt="Safety Incidents" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Safety Incidents</span>
            </router-link>

            <router-link to="/admin/safety/certifications" class="nav-item group">
              <img src="/src/assets/images/icons/checklist and pen.png" alt="Certifications" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Certifications</span>
            </router-link>

            <router-link to="/admin/safety/training" class="nav-item group">
              <img src="/src/assets/images/icons/books.png" alt="Training" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Training</span>
            </router-link>
          </div>
        </div>

        <div class="mb-8">
          <div class="flex items-center px-3 py-2 text-xs font-semibold text-slate-400 uppercase tracking-wider mb-3">
            <span>Account</span>
          </div>
          <div class="space-y-1">
            <router-link to="/admin/profile" class="nav-item group">
              <img src="/src/assets/images/icons/checklist and pen.png" alt="Profile" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Profile</span>
            </router-link>

            <router-link to="/admin/account-settings" class="nav-item group">
              <img src="/src/assets/images/icons/gear icon with neon.png" alt="Account Settings" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Account Settings</span>
            </router-link>

            <router-link to="/admin/preferences" class="nav-item group">
              <img src="/src/assets/images/icons/calendar with star.png" alt="Preferences" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Preferences</span>
            </router-link>

            <router-link to="/admin/support" class="nav-item group">
              <img src="/src/assets/images/icons/customer service.png" alt="Support" class="w-6 h-6 mr-3 group-hover:scale-110 transition-transform">
              <span>Support</span>
            </router-link>
          </div>
        </div>
      </nav>

      <!-- Admin Profile Section -->
      <div class="p-4 border-t border-slate-700/50 flex-shrink-0">
        <div class="flex items-center space-x-3 p-3 bg-slate-700/30 rounded-xl hover:bg-slate-600/50 transition-all duration-200 cursor-pointer group mb-3" @click="handleProfileClick">
          <div class="w-10 h-10 bg-gradient-to-br from-emerald-400 to-cyan-400 rounded-xl flex items-center justify-center shadow-lg group-hover:scale-105 transition-transform">
            <span class="text-sm font-bold text-white">
              {{ adminInitials || 'A' }}
            </span>
          </div>
          <div class="flex-1 min-w-0">
            <p class="text-sm font-semibold text-white group-hover:text-emerald-400 transition-colors truncate">{{ adminName || 'Admin' }}</p>
            <p class="text-xs text-slate-400">{{ adminEmail || 'admin@oilbuddy.ai' }}</p>
          </div>
          <svg class="w-4 h-4 text-slate-400 group-hover:text-emerald-400 transition-colors" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M8 9l4-4 4 4m0 6l-4 4-4-4"/>
          </svg>
        </div>
        
        <!-- Logout Button -->
        <button @click="logout" class="w-full flex items-center justify-center space-x-2 px-3 py-2 text-red-400 hover:text-red-300 hover:bg-red-500/10 rounded-lg transition-all duration-200">
          <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
          </svg>
          <span class="text-sm font-medium">Sign Out</span>
        </button>
      </div>
    </div>

    <!-- Main Content Area -->
    <div class="ml-72 min-h-screen">
      <!-- Top Navigation Bar -->
      <div class="fixed top-0 left-72 right-0 z-40 bg-slate-800/90 backdrop-blur-xl border-b border-slate-700/50">
        <div class="flex items-center justify-between px-6 py-4">
          <!-- Left side - Page title -->
          <div class="flex items-center space-x-4">
            <h1 class="text-xl font-semibold text-white">{{ pageTitle || 'Admin Panel' }}</h1>
            <span class="text-sm text-slate-400">{{ pageSubtitle || 'Manage the OilBuddy platform' }}</span>
          </div>
          
          <!-- Right side - Navigation items -->
          <div class="flex items-center space-x-4">
            <!-- Notifications -->
            <button class="relative p-2 text-slate-400 hover:text-emerald-400 transition-colors rounded-lg">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 17h5l-5 5v-5zM15 17H9a2 2 0 01-2-2V5a2 2 0 012-2h6a2 2 0 012 2v10z"/>
              </svg>
              <div class="absolute top-1 right-1 w-2 h-2 bg-emerald-400 rounded-full animate-pulse"></div>
            </button>

            <!-- Settings -->
            <router-link to="/admin/settings" class="p-2 text-slate-400 hover:text-emerald-400 transition-colors rounded-lg">
              <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
              </svg>
            </router-link>

            <!-- Avatar Dropdown -->
            <div class="relative">
              <button @click="showUserDropdown = !showUserDropdown" class="flex items-center space-x-3 p-2 rounded-lg hover:bg-slate-800/50 transition-colors">
                <div class="w-8 h-8 bg-gradient-to-br from-emerald-400 to-cyan-400 rounded-full flex items-center justify-center">
                  <span class="text-sm font-bold text-slate-900">{{ adminInitials || 'A' }}</span>
                </div>
                <div class="hidden md:block text-left">
                  <p class="text-sm font-medium text-white">{{ adminName || 'Admin' }}</p>
                  <p class="text-xs text-slate-400">{{ adminEmail || 'admin@oilbuddy.ai' }}</p>
                </div>
                <svg class="w-4 h-4 text-slate-400" :class="{ 'rotate-180': showUserDropdown }" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                  <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M19 9l-7 7-7-7"/>
                </svg>
              </button>

              <!-- Dropdown Menu -->
              <div v-if="showUserDropdown" class="absolute right-0 mt-2 w-64 bg-slate-800/95 backdrop-blur-xl border border-slate-700/50 rounded-2xl shadow-2xl shadow-black/20 py-2">
                <!-- Admin Info Header -->
                <div class="px-4 py-3 border-b border-slate-700/50">
                  <div class="flex items-center space-x-3">
                    <div class="w-12 h-12 bg-gradient-to-br from-emerald-400 to-cyan-400 rounded-full flex items-center justify-center">
                      <span class="text-lg font-bold text-slate-900">{{ adminInitials || 'A' }}</span>
                    </div>
                    <div>
                      <p class="text-sm font-semibold text-white">{{ adminName || 'Admin' }}</p>
                      <p class="text-xs text-slate-400">{{ adminEmail || 'admin@oilbuddy.ai' }}</p>
                      <p class="text-xs text-emerald-400 font-medium">Administrator</p>
                    </div>
                  </div>
                </div>

                <!-- Menu Items -->
                <div class="py-2">
                  <router-link 
                    to="/admin/profile" 
                    class="flex items-center space-x-3 px-4 py-2 text-slate-300 hover:bg-slate-700/50 hover:text-emerald-400 transition-colors"
                    @click="showUserDropdown = false"
                  >
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M16 7a4 4 0 11-8 0 4 4 0 018 0zM12 14a7 7 0 00-7 7h14a7 7 0 00-7-7z"/>
                    </svg>
                    <span>My Profile</span>
                  </router-link>
                  
                  <router-link 
                    to="/admin/account-settings" 
                    class="flex items-center space-x-3 px-4 py-2 text-slate-300 hover:bg-slate-700/50 hover:text-emerald-400 transition-colors"
                    @click="showUserDropdown = false"
                  >
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M10.325 4.317c.426-1.756 2.924-1.756 3.35 0a1.724 1.724 0 002.573 1.066c1.543-.94 3.31.826 2.37 2.37a1.724 1.724 0 001.065 2.572c1.756.426 1.756 2.924 0 3.35a1.724 1.724 0 00-1.066 2.573c.94 1.543-.826 3.31-2.37 2.37a1.724 1.724 0 00-2.572 1.065c-.426 1.756-2.924 1.756-3.35 0a1.724 1.724 0 00-2.573-1.066c-1.543.94-3.31-.826-2.37-2.37a1.724 1.724 0 00-1.065-2.572c-1.756-.426-1.756-2.924 0-3.35a1.724 1.724 0 001.066-2.573c-.94-1.543.826-3.31 2.37-2.37.996.608 2.296.07 2.572-1.065z"/>
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M15 12a3 3 0 11-6 0 3 3 0 016 0z"/>
                    </svg>
                    <span>Account Settings</span>
                  </router-link>
                  
                  <router-link 
                    to="/admin/preferences" 
                    class="flex items-center space-x-3 px-4 py-2 text-slate-300 hover:bg-slate-700/50 hover:text-emerald-400 transition-colors"
                    @click="showUserDropdown = false"
                  >
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 6V4m0 2a2 2 0 100 4m0-4a2 2 0 110 4m-6 8a2 2 0 100-4m0 4a2 2 0 100-4m0 4v2m0-6V4m6 6v10m6-2a2 2 0 100-4m0 4a2 2 0 100-4m0 4v2m0-6V4"/>
                    </svg>
                    <span>Preferences</span>
                  </router-link>
                  
                  <div class="border-t border-slate-700/50 my-2"></div>
                  
                  <router-link 
                    to="/admin/support" 
                    class="flex items-center space-x-3 px-4 py-2 text-slate-300 hover:bg-slate-700/50 hover:text-emerald-400 transition-colors"
                    @click="showUserDropdown = false"
                  >
                    <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M18.364 5.636l-3.536 3.536m0 5.656l3.536 3.536M9.172 9.172L5.636 5.636m3.536 9.192L5.636 18.364M21 12a9 9 0 11-18 0 9 9 0 0118 0zm-5 0a4 4 0 11-8 0 4 4 0 018 0z"/>
                    </svg>
                    <span>Support</span>
                  </router-link>
                  
                  <div class="border-t border-slate-700/50 my-2"></div>
                  
                  <button @click="logout" class="w-full flex items-center space-x-3 px-4 py-2 text-red-400 hover:text-red-300 hover:bg-red-500/10 transition-colors">
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                      <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M17 16l4-4m0 0l-4-4m4 4H7m6 4v1a3 3 0 01-3 3H6a3 3 0 01-3-3V7a3 3 0 013-3h4a3 3 0 013 3v1"/>
                    </svg>
                    <span class="text-sm font-medium">Sign Out</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Page Content -->
      <div class="pt-24 p-6">
        <slot></slot>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import { computed, onMounted, onUnmounted, ref } from 'vue'
import { useRouter } from 'vue-router'
import { useAdminStore } from '../../stores/adminStore'

interface Props {
  pageTitle?: string
  pageSubtitle?: string
}

withDefaults(defineProps<Props>(), {
  pageTitle: 'Admin Panel',
  pageSubtitle: 'Manage the OilBuddy platform'
})

const router = useRouter()
const adminStore = useAdminStore()

const showUserDropdown = ref(false)

// Computed properties
const adminInitials = computed(() => {
  const name = adminStore.currentAdmin?.name || 'Admin'
  return name.split(' ').map(word => word.charAt(0)).join('').toUpperCase().slice(0, 2)
})

const adminName = computed(() => adminStore.currentAdmin?.name || 'Admin')
const adminEmail = computed(() => adminStore.currentAdmin?.email || 'admin@oilbuddy.ai')

// Methods
const handleProfileClick = () => {
  showUserDropdown.value = !showUserDropdown.value
}

const logout = () => {
  adminStore.logout()
  window.location.href = '/#/admin/login'
}

// Click outside listener
const handleClickOutside = (event: Event) => {
  const target = event.target as HTMLElement
  if (!target.closest('.relative')) {
    showUserDropdown.value = false
  }
}

onMounted(() => {
  document.addEventListener('click', handleClickOutside)
})

onUnmounted(() => {
  document.removeEventListener('click', handleClickOutside)
})
</script>

<style scoped>
/* Background patterns */
.bg-grid-pattern {
  background-image: radial-gradient(circle, rgba(148, 163, 184, 0.3) 1px, transparent 1px);
  background-size: 50px 50px;
  animation: grid-move 20s linear infinite;
}

@keyframes grid-move {
  0% { background-position: 0 0; }
  100% { background-position: 50px 50px; }
}

/* Floating particles */
.particle {
  position: absolute;
  width: 4px;
  height: 4px;
  background: linear-gradient(45deg, #10b981, #06b6d4);
  border-radius: 50%;
  animation: float 6s ease-in-out infinite;
}

.particle-1 { top: 20%; left: 10%; animation-delay: 0s; }
.particle-2 { top: 60%; left: 80%; animation-delay: 2s; }
.particle-3 { top: 80%; left: 20%; animation-delay: 4s; }
.particle-4 { top: 40%; left: 70%; animation-delay: 1s; }
.particle-5 { top: 70%; left: 40%; animation-delay: 3s; }

@keyframes float {
  0%, 100% { transform: translateY(0px) rotate(0deg); opacity: 1; }
  50% { transform: translateY(-20px) rotate(180deg); opacity: 0.8; }
}

/* Navigation active states */
.nav-item.router-link-active {
  @apply bg-gradient-to-r from-emerald-500/20 to-cyan-500/20 text-emerald-400 border-l-4 border-emerald-500;
}

.nav-item.router-link-active img {
  @apply scale-110;
}

/* Custom scrollbar */
.custom-scrollbar {
  scrollbar-width: thin;
  scrollbar-color: rgba(100, 116, 139, 0.5) transparent;
}

.custom-scrollbar::-webkit-scrollbar {
  width: 6px;
}

.custom-scrollbar::-webkit-scrollbar-track {
  background: transparent;
}

.custom-scrollbar::-webkit-scrollbar-thumb {
  background: rgba(100, 116, 139, 0.5);
  border-radius: 3px;
}

.custom-scrollbar::-webkit-scrollbar-thumb:hover {
  background: rgba(100, 116, 139, 0.8);
}

/* Navigation styles */
.nav-item {
  @apply flex items-center space-x-3 px-4 py-3 text-slate-300 rounded-xl hover:bg-slate-800/50 hover:text-emerald-400 transition-all duration-300;
}
</style>
